/* es5-ext/function/noop */ function _(require, module, exports) {
    // eslint-disable-next-line no-empty-function
    module.exports = function () { };
}
